import { WiFi, NoAlert, Passport } from '@assets/svg';
import { Flex, Text } from '@components';
import ChoiceInput from '@components/ChoiceInput/ChoiceInput';
import { useTheme } from '@mui/material';
import InvestmentFooter from '@pages/Investment/InvestmentFooter/InvestmentFooter';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { Steps as ProgressSteps } from '../Progress/Progress.types';
import { Container, ContentContainer } from './IdentityVerification.styles';
import WithUser, { WithUserProps } from '@HOCs/withUser';

const IdentityVerificationIntro: React.FC<WithUserProps> = ({ user }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const intl = useIntl();
  const { productId } = useParams();

  const onNextButtonClick = (): void => {
    navigate(`/investment-subscription/${productId}/identity-verification`, {
      state: {
        progress: 7,
      },
      replace: true,
    });
  };

  return (
    <Container>
      <ContentContainer>
        <Text
          variant='h3'
          fontWeight='fontWeightBold'
          mt={5}
          color={theme.palette.black.A100}
        >
          <FormattedMessage id='investment.identityVerification.idVerification' />
        </Text>
        <Text
          variant='h6'
          mt={5}
          fontWeight='fontWeightMedium'
          color={theme.palette.black[500]}
        >
          <FormattedMessage id='investment.identityVerification.message' />
        </Text>
        <Text
          variant='h6'
          fontWeight='fontWeightMedium'
          color={theme.palette.black[500]}
          marginTop={10}
        >
          <FormattedMessage id='investment.identityVerification.requirements' />
        </Text>
        <Flex
          sx={{
            marginTop: theme.spacing(12),
            flexDirection: 'column',
            maxWidth: {
              xs: '100%',
              md: '85%',
            },
          }}
        >
          <ChoiceInput
            direction='column'
            choices={[
              {
                id: 'id_passport',
                title: intl.formatMessage({
                  id: 'investment.identityVerification.idOrPassport',
                }),
                adornmentLeft: <Passport />,
              },
              {
                id: 'reliable_internet',
                title: intl.formatMessage({
                  id: 'investment.identityVerification.reliableInternet',
                }),
                adornmentLeft: <WiFi />,
              },
              {
                id: 'quiet_environment',
                title: intl.formatMessage({
                  id: 'investment.identityVerification.quietEnvironment',
                }),
                adornmentLeft: <NoAlert />,
              },
            ]}
            readonly
          />
        </Flex>
      </ContentContainer>
      <InvestmentFooter
        secondaryButton={{
          title: intl.formatMessage({
            id: 'misc.previous',
          }),
          onClick: () =>
            navigate(`/investment-subscription/${productId}/progress`, {
              state: {
                completedSteps: [ProgressSteps.Details],
                progress: 6,
              },
              replace: true,
            }),
        }}
        primaryButton={{
          title: intl.formatMessage({
            id: 'investment.identityVerification.proceedToIDV',
          }),
          onClick: onNextButtonClick,
        }}
      />
    </Container>
  );
};

export default WithUser(IdentityVerificationIntro);
